<template>
  <v-card outlined class="pedido" :class="'pedido--' + nivel">
    <div class="pedido__cabecera">
      <div class="pedido__mesa">
        <span v-if="posicion" class="pedido__posicion" :title="posicion === 1 ? 'El que sigue' : 'Lugar en la fila'">{{ posicion }}</span>
        <v-icon class="mr-1">{{ modoEntrega ? "mdi-receipt-text-outline" : "mdi-table-furniture" }}</v-icon>{{ titulo }}
      </div>
      <div class="pedido__tiempo">
        <v-icon small color="inherit" class="mr-1">mdi-clock-outline</v-icon>{{ tiempo }}
      </div>
    </div>

    <div v-if="atendio || etiqueta || (modoEntrega && cliente)" class="pedido__origen">
      <span v-if="etiqueta" class="pedido__etiqueta">{{ etiqueta }}</span>
      <span v-if="modoEntrega && cliente"><v-icon x-small color="inherit" class="mr-1">mdi-account-circle-outline</v-icon>{{ cliente }}</span>
      <span v-if="atendio"><v-icon x-small color="inherit" class="mr-1">mdi-account-outline</v-icon>{{ atendio }}</span>
    </div>

    <div v-if="enPreparacion && totalLineas > 1" class="pedido__avance">
      <v-progress-linear :value="(listas / totalLineas) * 100" color="#2e7d5b" height="8" rounded background-color="grey lighten-3" />
      <span>{{ listas }} de {{ totalLineas }} listas</span>
    </div>

    <div v-if="item.note" class="pedido__nota">
      <v-icon small color="inherit" class="mr-1">mdi-comment-text-outline</v-icon>{{ item.note }}
    </div>

    <div class="pedido__lineas">
      <div v-for="it of item.data_items" :key="it.id" class="pedido__linea" :class="{
        'pedido__linea--preparando': it.status === 'preparing',
        'pedido__linea--lista': it.status === 'prepared',
        'pedido__linea--imposible': it.status === 'unavailable',
      }">
        <span class="pedido__cantidad"><small>x</small>{{ it.quantity }}</span>
        <div class="pedido__nombre">
          {{ it.product.name }}
          <v-btn v-if="!modoEntrega" icon small class="pedido__info" title="Ver descripción y receta" @click.stop="$emit('ver-producto', it.product)">
            <v-icon small color="#a31d48">mdi-information-outline</v-icon>
          </v-btn>
          <div v-for="(d, j) in detalle(it)" :key="'d' + j" class="pedido__detalle">{{ d }}</div>
          <span v-if="it.note" class="pedido__nota-linea">
            <v-icon small color="inherit" class="mr-1">mdi-comment-alert-outline</v-icon>{{ it.note }}
          </span>
        </div>
        <div v-if="it.status === 'unavailable'" class="pedido__imposible">
          <v-icon small color="inherit">mdi-cancel</v-icon> No se puede<span v-if="razon(it)">: {{ razon(it) }}</span>
        </div>
        <v-btn v-if="$store.getters.isRestaurant && enPreparacion && it.status !== 'prepared' && it.status !== 'unavailable'" icon small title="No se puede preparar"
          class="pedido__no-se-puede" @click.stop="abrirImposible(it)">
          <v-icon small color="grey darken-1">mdi-cancel</v-icon>
        </v-btn>
        <template v-if="enPreparacion && it.status !== 'unavailable'">
          <v-btn v-if="!it.status" small rounded outlined color="#2e7d5b" @click="$emit('iniciar-linea', it)">Iniciar</v-btn>
          <v-btn v-else-if="it.status === 'preparing'" small rounded depressed dark color="#2e7d5b"
            @click="$emit('terminar-linea', it)">Listo</v-btn>
          <v-icon v-else color="#2e7d5b">mdi-check-circle</v-icon>
        </template>
      </div>
    </div>

    <v-btn block tile depressed large class="pedido__accion" :class="{ 'pedido__accion--lista': todoListo }" :color="enPreparacion || modoEntrega ? '#2e7d5b' : '#a31d48'" dark
      @click="accion">
      <v-icon left>{{ modoEntrega ? "mdi-package-variant-closed-check" : enPreparacion ? "mdi-check-circle" : "mdi-ray-start-arrow" }}</v-icon>
      {{ modoEntrega ? "Entregar" : enPreparacion ? "Finalizar" : "Preparar" }}
    </v-btn>

    <v-dialog v-model="imposible" max-width="480">
      <v-card v-if="lineaImposible">
        <v-card-title class="pedido__confirmar-titulo">No se puede preparar</v-card-title>
        <v-card-text>
          <p class="pedido__confirmar-texto">x{{ lineaImposible.quantity }} {{ lineaImposible.product.name }} ({{ titulo }}). Se le avisa a la caja y al mesero; el resto del pedido sigue.</p>
          <div class="mb-3">
            <v-chip v-for="m in motivos" :key="m" class="mr-1 mb-1" :outlined="motivoSel !== m"
              :color="motivoSel === m ? '#a31d48' : undefined" :dark="motivoSel === m"
              @click="motivoSel = m">{{ m }}</v-chip>
          </div>
          <v-checkbox v-if="motivoSel === 'Se agotó'" v-model="marcarAgotado" hide-details dense class="mt-0 mb-3"
            label="Marcar también el producto como agotado (no se podrá pedir hasta el próximo turno)"></v-checkbox>
          <v-textarea v-model="notaImposible" outlined rows="2" hide-details
            :label="motivoSel === 'Otro' ? 'Cuéntale a la caja qué pasó (obligatorio)' : 'Nota (opcional)'"></v-textarea>
          <div class="red--text caption mt-2" v-if="errorImposible">{{ errorImposible }}</div>
        </v-card-text>
        <v-card-actions class="px-6 pb-5">
          <v-btn large outlined @click="imposible = false">Volver</v-btn>
          <v-spacer></v-spacer>
          <v-btn large depressed color="#a31d48" class="white--text" :disabled="!puedeImposible" @click="confirmarImposible">No se puede</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmar" max-width="440">
      <v-card class="pedido__confirmar">
        <v-card-title class="pedido__confirmar-titulo">
          <v-icon color="amber darken-3" large class="mr-2">mdi-alert-outline</v-icon>{{ sinListo.length ? "Faltan productos" : "Preparación especial" }}
        </v-card-title>
        <v-card-text>
          <template v-if="sinListo.length">
            <p class="pedido__confirmar-texto">
              Faltan {{ sinListo.length }} {{ sinListo.length === 1 ? "producto" : "productos" }} por marcar como
              {{ sinListo.length === 1 ? "listo" : "listos" }} ({{ titulo }}):
            </p>
            <div v-for="it of sinListo" :key="'falta' + it.id" class="pedido__falta">x{{ it.quantity }} {{ it.product.name }}</div>
          </template>
          <p v-if="item.note || lineasEspeciales.length" class="pedido__confirmar-texto" :class="{ 'mt-4': sinListo.length }">
            Este pedido tenía algo distinto a lo normal. ¿Lo hiciste así?
          </p>
          <div v-if="item.note" class="pedido__nota pedido__nota--dialogo">
            <v-icon small color="inherit" class="mr-1">mdi-comment-text-outline</v-icon>{{ item.note }}
          </div>
          <div v-for="it of lineasEspeciales" :key="it.id" class="pedido__especial">
            <span class="pedido__especial-nombre">x{{ it.quantity }} {{ it.product.name }}</span>
            <span class="pedido__nota-linea"><v-icon small color="inherit" class="mr-1">mdi-comment-alert-outline</v-icon>{{ it.note }}</span>
          </div>
        </v-card-text>
        <v-card-actions class="px-6 pb-5">
          <v-btn large outlined @click="confirmar = false">Volver</v-btn>
          <v-spacer></v-spacer>
          <v-btn large depressed dark color="#2e7d5b" @click="confirmarFinalizar">
            {{ sinListo.length ? "Finalizar de todos modos" : "Sí, finalizar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import * as moment from "moment-timezone";
import { razonImposible } from "@/plugins/pedidos-rechazados";

// Minutos desde que entró el pedido: hasta MINUTOS_ALERTA va en verde, hasta MINUTOS_TARDE en ámbar y después en rojo.
const MINUTOS_ALERTA = 10;
const MINUTOS_TARDE = 20;

export default {
  name: "TarjetaPedido",
  props: {
    item: { type: Object, required: true },
    enPreparacion: { type: Boolean, default: false },
    // Negocios que no son restaurante: el pedido ya está cobrado y solo falta entregarlo.
    modoEntrega: { type: Boolean, default: false },
    // La hora actual (ms), que la lista renueva cada tanto para que el tiempo y el color avancen solos.
    ahora: { type: Number, required: true },
    // Lugar en la fila de su columna (1 = el más antiguo, el que sigue).
    posicion: { type: Number, default: 0 },
  },
  data: () => ({
    confirmar: false,
    imposible: false,
    lineaImposible: null,
    motivos: ["Se agotó", "Falta un ingrediente", "No hay cómo prepararlo", "Otro"],
    motivoSel: null,
    notaImposible: "",
    marcarAgotado: true,
    errorImposible: "",
  }),
  methods: {
    // Lo que va con el producto y cocina tiene que ver: la variante (talla, presentación), las opciones
    // elegidas («término medio») y los productos que lo acompañan (combo, adicionales).
    detalle(it) {
      const detalle = [];
      if (it.product_variant && it.product_variant.name) detalle.push(it.product_variant.name);
      const opciones = it.options || {};
      for (const k of Object.keys(opciones)) {
        const op = opciones[k];
        if (!op || op.option_type !== "custom") continue;
        const valor = Array.isArray(op.value) ? op.value.join(", ") : op.value;
        if (valor) detalle.push(op.name + ": " + valor);
      }
      for (const sub of it.sub_items || []) {
        if (sub && sub.product) detalle.push(sub.quantity + " × " + sub.product.name);
      }
      return detalle;
    },
    razon(it) {
      return razonImposible(this.item, (this.item.data_items || []).indexOf(it));
    },
    abrirImposible(it) {
      this.lineaImposible = it;
      this.motivoSel = null;
      this.notaImposible = "";
      this.errorImposible = "";
      this.imposible = true;
    },
    confirmarImposible() {
      this.$emit("imposible-linea", this.lineaImposible, { mark_sold_out: this.motivoSel === "Se agotó" && this.marcarAgotado, reason: this.motivoSel + (this.notaImposible.trim() ? ": " + this.notaImposible.trim() : "") });
      this.imposible = false;
    },
    persona(valor) {
      let p = valor;
      if (typeof p === "string") {
        try {
          p = JSON.parse(p);
        } catch (e) {
          return "";
        }
      }
      return p && p.name ? p.name : "";
    },
    // Al finalizar, si el pedido tenía algo especial, se le recuerda a la cocina antes de darlo por listo.
    accion() {
      if (this.enPreparacion && (this.sinListo.length || this.item.note || this.lineasEspeciales.length)) {
        this.confirmar = true;
        return;
      }
      this.$emit("accion");
    },
    confirmarFinalizar() {
      this.confirmar = false;
      this.$emit("accion");
    },
  },
  computed: {
    // Quién lo tomó: el mesero si vino de la app de meseros, si no quien está en la caja.
    atendio() {
      const mesero = this.persona(this.item.data_seller);
      if (mesero) return `Mesero: ${mesero}`;
      const cajero = this.persona(this.item.data_cashier);
      return cajero ? `Caja: ${cajero}` : "";
    },
    // El tipo, solo cuando cambia lo que hace la cocina.
    etiqueta() {
      if (this.item.is_domicile) return "Domicilio";
      // Una venta de mostrador no es «para llevar» por el solo hecho de no tener mesa.
      if (this.modoEntrega) return "";
      // El pedido toma «recoger en tienda» por defecto, también cuando va a una mesa: solo es para llevar si no tiene mesa.
      if (this.item.store_pickup && !this.item.name_table) return "Para llevar";
      return "";
    },
    titulo() {
      if (this.modoEntrega) return this.item.consecutive_order_text ? "Pedido " + this.item.consecutive_order_text : "Pedido por entregar";
      return this.item.name_table || this.etiqueta || "Sin mesa";
    },
    cliente() {
      let c = this.item.data_customer;
      if (typeof c === "string") {
        try {
          c = JSON.parse(c);
        } catch (e) {
          return "";
        }
      }
      if (!c) return "";
      return [c.first_name || c.name || c.business_name, c.last_name].filter(Boolean).join(" ");
    },
    // Líneas a las que aún no se les dio "Listo".
    sinListo() {
      return (this.item.data_items || []).filter((it) => it.status !== "prepared" && it.status !== "unavailable");
    },
    puedeImposible() {
      if (!this.motivoSel) return false;
      return this.motivoSel !== "Otro" || this.notaImposible.trim().length >= 3;
    },
    // Líneas con nota (sin cebolla, bien tostada...): lo que no es la preparación normal.
    lineasEspeciales() {
      return (this.item.data_items || []).filter((it) => it.note);
    },
    totalLineas() {
      return (this.item.data_items || []).filter((it) => it.status !== "unavailable").length;
    },
    listas() {
      return (this.item.data_items || []).filter((it) => it.status === "prepared").length;
    },
    // Todas las líneas terminadas: solo falta entregar el pedido.
    todoListo() {
      return this.enPreparacion && this.totalLineas > 0 && this.listas === this.totalLineas;
    },
    minutos() {
      // Por entregar cuenta desde que se cobró; en cocina, desde que entró el pedido.
      const desde = (this.modoEntrega && this.item.closing_date) || this.item.opening_date || this.item.date_order;
      if (!desde) return 0;
      return Math.max(0, Math.floor((this.ahora - moment.tz(desde, "America/Bogota").valueOf()) / 60000));
    },
    nivel() {
      if (this.minutos >= MINUTOS_TARDE) return "tarde";
      if (this.minutos >= MINUTOS_ALERTA) return "alerta";
      return "ok";
    },
    tiempo() {
      if (this.minutos < 1) return "Recién llegó";
      if (this.minutos < 60) return `Hace ${this.minutos} min`;
      return `Hace ${Math.floor(this.minutos / 60)} h ${this.minutos % 60} min`;
    },
  },
};
</script>

<style>
.pedido {
  --nivel: #2e7d5b;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-left: 5px solid var(--nivel) !important;
}

.pedido--alerta {
  --nivel: #d4900a;
}

.pedido--tarde {
  --nivel: #b3203f;
}

.pedido__cabecera {
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 14px 8px;
}

.pedido__posicion {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 26px;
  margin-right: 8px;
  border-radius: 50%;
  font-size: 0.9rem;
  font-weight: 800;
  color: #a31d48;
  background: #f6e3ea;
}

.pedido__mesa {
  white-space: nowrap;
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.2;
}

.pedido__tiempo {
  display: flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 0.95rem;
  font-weight: 600;
  white-space: nowrap;
  color: var(--nivel);
  background: color-mix(in srgb, var(--nivel) 14%, transparent);
}

.pedido--alerta .pedido__tiempo {
  color: #9a6400;
}

.pedido__nota {
  margin: 0 14px 6px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 1.2rem;
  font-weight: 800;
  color: #7a4b00;
  background: #ffe082;
}

.pedido__origen {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 10px;
  padding: 0 14px 6px;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.6);
}

.pedido__etiqueta {
  padding: 1px 10px;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #fff;
  background: #a31d48;
}

.pedido__avance {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 14px 6px;
  font-size: 0.9rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
  white-space: nowrap;
}

.pedido__avance .v-progress-linear {
  flex: 1;
}

.pedido__accion--lista {
  animation: pedido-listo 1.4s ease-in-out infinite;
}

@keyframes pedido-listo {
  50% {
    filter: brightness(1.18);
  }
}

.pedido__lineas {
  flex: 1 1 auto;
  padding: 4px 10px 10px;
  max-height: 280px;
  overflow-y: auto;
}

.pedido__linea {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 10px 6px;
  border-radius: 8px;
  font-size: 1.15rem;
}

.pedido__linea + .pedido__linea {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.pedido__linea--preparando {
  background: #fdf3de;
}

.pedido__linea--lista {
  background: #ecf8ec;
  color: rgba(0, 0, 0, 0.55);
}

.pedido__cantidad {
  flex: 0 0 auto;
  min-width: 52px;
  height: 52px;
  padding: 0 10px;
  border-radius: 12px;
  display: flex;
  align-items: baseline;
  justify-content: center;
  padding-top: 8px;
  font-size: 1.9rem;
  font-weight: 800;
  line-height: 1.2;
  color: #fff;
  background: #263238;
}

.pedido__cantidad small {
  margin-right: 2px;
  font-size: 1rem;
  font-weight: 700;
  opacity: 0.75;
}

.pedido__info {
  margin-top: -2px;
  margin-left: 2px;
  background: #f6e3ea;
}

.pedido__nombre {
  flex: 1 1 180px;
  min-width: 0;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.25;
}

.pedido__detalle {
  margin-top: 4px;
  padding-left: 10px;
  border-left: 4px solid #a31d48;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.25;
  color: rgba(0, 0, 0, 0.75);
}

.pedido__linea--lista .pedido__detalle {
  border-left-color: #2e7d5b;
}

.pedido__linea--imposible .pedido__nombre {
  text-decoration: line-through;
  opacity: 0.6;
}

.pedido__imposible {
  flex-basis: 100%;
  margin-top: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #b71c1c;
}

.pedido__nota-linea {
  animation: pedido-nota 1.8s ease-in-out infinite;
  display: flex;
  align-items: center;
  width: fit-content;
  margin-top: 4px;
  padding: 3px 10px;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 700;
  color: #7a4b00;
  background: #ffe082;
}

.pedido__linea--lista .pedido__nota-linea {
  animation: none;
}

@keyframes pedido-nota {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(255, 160, 0, 0);
  }
  50% {
    box-shadow: 0 0 0 5px rgba(255, 160, 0, 0.55);
  }
}

@media (prefers-reduced-motion: reduce) {
  .pedido__nota-linea {
    animation: none;
  }
}

.pedido__confirmar-titulo {
  font-weight: 800;
}

.pedido__confirmar-texto {
  font-size: 1.1rem;
  color: rgba(0, 0, 0, 0.8);
}

.pedido__nota--dialogo {
  margin: 0 0 8px;
}

.pedido__falta {
  margin-top: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 1.2rem;
  font-weight: 700;
  color: #7b1230;
  background: #f6e3ea;
}

.pedido__especial {
  margin-top: 10px;
}

.pedido__especial-nombre {
  display: block;
  font-size: 1.25rem;
  font-weight: 700;
}

.pedido__accion {
  flex: 0 0 auto !important;
  height: 56px !important;
  font-size: 1.05rem !important;
  font-weight: 700;
  letter-spacing: 0.04em;
}
</style>
